export const applyMobileInputHints = (rootElement) => {
  if (!rootElement) {
    return;
  }

  const inputs = rootElement.querySelectorAll('input, textarea, select');

  inputs.forEach((field) => {
    const tag = field.tagName.toLowerCase();
    if (tag !== 'input') {
      return;
    }

    const type = (field.getAttribute('type') || 'text').toLowerCase();
    const placeholder = (field.getAttribute('placeholder') || '').toLowerCase();
    const name = (field.getAttribute('name') || '').toLowerCase();
    const labelText = (
      field.closest('.input-group')?.querySelector('label')?.textContent ||
      field.closest('label')?.textContent ||
      ''
    ).toLowerCase();

    const isPhoneLike =
      type === 'tel' ||
      /phone|mobile|contact/.test(name) ||
      /phone|mobile|contact/.test(placeholder) ||
      /phone|mobile|contact/.test(labelText) ||
      placeholder.includes('+91');

    if (type === 'number') {
      if (!field.getAttribute('inputmode')) {
        field.setAttribute('inputmode', 'decimal');
      }
      if (!field.getAttribute('enterkeyhint')) {
        field.setAttribute('enterkeyhint', 'done');
      }
      return;
    }

    if (isPhoneLike) {
      if (!field.getAttribute('inputmode')) {
        field.setAttribute('inputmode', 'tel');
      }
      if (!field.getAttribute('autocomplete')) {
        field.setAttribute('autocomplete', 'tel');
      }
      return;
    }

    if (type === 'email') {
      if (!field.getAttribute('inputmode')) {
        field.setAttribute('inputmode', 'email');
      }
      if (!field.getAttribute('autocomplete')) {
        field.setAttribute('autocomplete', 'email');
      }
    }
  });
};
